import './OnboardingSteps.scss';
import React from 'react';
import { Steps } from 'antd';

export enum OnboardingStep {
	Connect = 'Connect',
	Team = 'Team',
	Failed = 'Failed'
}

export interface OnboardingStepsProps {
	currentStep: OnboardingStep;
}

const flow = [ OnboardingStep.Connect, OnboardingStep.Team ];

export const OnboardingSteps: React.FC<OnboardingStepsProps> = ({ currentStep }) =>
	<div className='onboarding-steps'>
		<Steps
			current={ flow.indexOf(currentStep) }
			items={ flow.map((step) => ({ title: step })) } />
	</div>;

